import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthDataAccess } from 'src/app/auth/data-access/auth.data-access';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthDataAccess);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  } else {
    router.navigate(['/auth/sign-in']);
    return false;
  }
};
